import React from "react";
import Box from "react-raster";
import { Heading, Text } from "src/components";
import { FontStyle, HeadingType, theme } from "src/config";

export const TypographySection = () => {
  return (
    <Box gridRowGap={theme.layout.gutterSmall}>
      <Heading weight="normal" type="h3" color="black">
        Typography
      </Heading>
      <Box>
        <hr />
      </Box>
      {["h1", "h2", "h3"].map((h: HeadingType) => (
        <Heading key={h} type={h} color="black" weight="normal">
          {"This is a " + h}
        </Heading>
      ))}
      {["italic", "oblique", "normal", "bold"].map((t: FontStyle) => (
        <Text
          key={"normal"}
          color="black"
          fontStyle={t}
          weight={t}
          size="default"
        >
          {`This paragraph is ${t}`}
        </Text>
      ))}
    </Box>
  );
};